function offsetCharTable(inputString, tableStartChar, tableEndChar, offset) {
  let result = "";

  for (const ch of inputString) {
    const code = ch.codePointAt(0);

    if (code >= tableStartChar && code <= tableEndChar) {
      result += String.fromCodePoint(code + offset);
    } else {
      result += ch; // leave untouched
    }
  }

  return result;
}

export default offsetCharTable;
